/** Splits whatever was pasted — commas, spaces, semicolons, new lines — into addresses. */
export function parseInviteEmails(raw: string): string[] {
  return [
    ...new Set(
      raw
        .split(/[\s,;]+/)
        .map((e) => e.trim().toLowerCase())
        .filter(Boolean)
    ),
  ];
}
